import React from "react";
import ReactDOM from "react-dom/client";
// Force all Date formatters to default to Asia/Kolkata (IST) across the entire
// app. Must be imported for its side-effects BEFORE any component renders.
import "@/utils/istTimezone";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
